import React, { useEffect } from 'react';
import Title from 'antd/lib/typography/Title';
import '../../../assets/css/spinner.css';
import { useGetCryptosQuery } from '../../../services/cryptoAPI';
import CryptoTable from '../../containers/CryptoTable/CryptoTable';


const CrytpoDashboard = () => {
   const {data: cryptosList} = useGetCryptosQuery();
   const allCoins = cryptosList?.data?.coins;

   const columns = [
      {
          title: 'Coin Rank',
          dataIndex: 'rank',
          key: 'rank',
          render: text => <strong>{text}</strong>,
      },
      {
          title: 'Coin Name',
          dataIndex: 'name',
          key: 'name',
      },
      {
          title: 'Price',
          dataIndex: 'price',
          key: 'price',
      },
      {
          title: 'Change',
          key: 'change',
          dataIndex: 'change',
          render: change => <span style={{color: `${change > 0 ? "green" : "red"}`}}> <strong>{change}</strong> </span>
      },
      {
          title: '24H Volume',
          key: 'volume',
          dataIndex: "volume",
      },
  ];
   
   useEffect(() => {
      window.scrollTo(0, 0);
      //eslint-disable-next-line
  }, [])

    return (
        <>
            {
               allCoins 
               ? (
                  <>
                     <div className="container pt-5 my-5 mx-auto">
                     <Title level={3} className="text-center pb-4" style={{color: "rgba(18, 15, 62, 0.91)"}}>
                        Trending Coins Around The World
                    </Title>
                        <CryptoTable data={allCoins} columns={columns}/>
                     </div>
                  </>
               )
               : <></>
            }         
        </>
    )
}

export default CrytpoDashboard
